import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StormMapDataService {

  private stormAnimationEndReachedSource = new Subject();
  readonly stormAnimationEndReached$ = this.stormAnimationEndReachedSource.asObservable();

  sendStormEndReached() {
    this.stormAnimationEndReachedSource.next(true);
  }
}
